// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__ZJd-u","spin":"styles_spin__1CFl-"};